<template>
  <div class="EditContainer mb20">
    <a-form :model="activityFormData" layout="vertical">
      <a-form-item label="状态" required>
        <a-radio-group
          v-model:value="activityFormData.status"
          :disabled="notDefaultLang"
        >
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">禁用</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="图片" required>
        <div class="upImg-wrapper">
          <UploadImg
            :type="'1'"
            :defaultUrl="
              activityFormData?.langs?.[
                activityFormData?.langs?.findIndex(v => v.langCode === langCode)
              ]?.pcImgUrl
            "
            :imageType="imageType.pc"
            @delActivityImg="delActivityImg"
            @setImgUrl="setImgUrl"
            v-if="queryParams.terminalId == 1"
          ></UploadImg>
          <UploadImg
            :type="'2'"
            :defaultUrl="
              activityFormData?.langs?.[
                activityFormData?.langs?.findIndex(v => v.langCode === langCode)
              ]?.mImgUrl
            "
            :imageType="imageType.m"
            @delActivityImg="delActivityImg"
            @setImgUrl="setImgUrl"
            v-if="queryParams.terminalId == 1"
          ></UploadImg>
          <UploadImg
            :type="'3'"
            :defaultUrl="
              activityFormData?.langs?.[
                activityFormData?.langs?.findIndex(v => v.langCode === langCode)
              ]?.appImgUrl
            "
            :imageType="imageType.app"
            @delActivityImg="delActivityImg"
            @setImgUrl="setImgUrl"
            v-if="queryParams.terminalId == 2"
          ></UploadImg>
        </div>
      </a-form-item>
      <a-form-item label="着陆页链接" class="w500">
        <a-input
          :disabled="notDefaultLang"
          v-model:value="activityFormData.entranceUrl"
          placeholder="请输入"
        />
      </a-form-item>
      <a-form-item label="活动起止时间（GTM+1）" required>
        <a-range-picker
          :disabled="notDefaultLang"
          v-model:value="activityFormData.timeSet"
          show-time
          :format="'YYYY-MM-DD HH:mm:ss'"
          :placeholder="['开始时间', '结束时间']"
          @change="timeChange"
        />
      </a-form-item>
      <a-form-item label="展示页面" required>
        <div class="page-item">
          <a-select
            v-model:value="activityFormData.showPage"
            mode="tags"
            style="width: 100%"
            placeholder="请选择"
            :fieldNames="{
              label: 'name',
              value: 'code'
            }"
            :options="showPageOptions"
            :disabled="activityFormData.isAllShow || notDefaultLang"
          >
          </a-select>
          <a-checkbox
            :disabled="notDefaultLang"
            v-model:checked="activityFormData.isAllShow"
            @change="isAllShowChange"
            >全站</a-checkbox
          >
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { inject, toRefs, computed } from 'vue'
import UploadImg from './UploadImg.vue'
export default {
  components: {
    UploadImg
  },
  setup() {
    const injectState = inject('initState')
    const notDefaultLang = computed(
      () => injectState.langCode !== injectState.defaultLanguageCode
    )
    return {
      notDefaultLang,
      ...toRefs(injectState)
    }
  }
}
</script>

<style lang="scss" scoped>
.EditContainer {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}
.upImg-wrapper {
  display: flex;
  align-items: center;
}
.page-item {
  display: flex;
  align-items: center;
  .ant-select {
    width: 500px !important;
    margin-right: 10px;
  }
}
</style>
